import { HTMLMotionProps } from "@enkor/framer-motion";

import { GA_EVENT_IDS } from "@domains/common/constants/googleAnalyticsIds";
import { grayScale } from "@enkor/design/colors";
import { Share2Icon } from "@enkor/design/icons";
import { LoadingSpinner } from "@enkor/design/components";
import { iconButtonAnimation } from "@domains/common/utils/animationHelper";

import * as S from "./BaseButtonGroup.style";

interface BaseButtonGroupProps {
  actionButtonProps: HTMLMotionProps<"button">;
  buttonContent?: string;
  onClickShare: () => void;
}

const BaseButtonGroup = ({
  actionButtonProps,
  buttonContent,
  onClickShare,
}: BaseButtonGroupProps) => {
  return (
    <S.ButtonGroupWrapper>
      <S.ShareButtonBox
        type="button"
        id={GA_EVENT_IDS.EVENT.GUEST_SHARE}
        {...iconButtonAnimation}
        onClick={onClickShare}
      >
        <Share2Icon strokeColor={grayScale.white} size={20} />
      </S.ShareButtonBox>
      <S.FullButton {...actionButtonProps} type="button">
        {buttonContent || (
          <LoadingSpinner loaderType="PulseLoader" color={grayScale.white} />
        )}
      </S.FullButton>
    </S.ButtonGroupWrapper>
  );
};

export default BaseButtonGroup;
